module.exports = __webpack_public_path__ + "img/icon10.958e8a6a.svg";